module.exports = __webpack_public_path__ + "src/assets/img/monkey.9a519994.svg";